/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PackageLatestEventVO } from '@well/delivery-libs/packages/domain';

@Injectable({
  providedIn: 'root',
})
export class PackagesResourceService extends AbstractResourceService<any, any, any, any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('packagesUrl'), undefined, undefined);
  }

  markAsLost(packageUuid: string): Observable<PackageLatestEventVO> | undefined {
    return this.httpClient?.post<PackageLatestEventVO>(`${this.url}/lost/${packageUuid}`, null, {
      headers: this.headers,
    });
  }

  downloadPackagePdf(uuid: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream',
    });
    return this.httpClient
      ?.get(`${this.url}/download-pdf/${uuid}`, {
        headers,
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe((res) => {
        const contentDisposition = res.headers.get('content-disposition');
        const fileName = contentDisposition
          ? contentDisposition.replace('attachment; filename=', '').replace(/"/g, '')
          : null;

        const link = document.createElement('a');
        link.href = res.body ? window.URL?.createObjectURL(res.body) : '';
        link.download = fileName ? fileName : '';
        link.click();
      });
  }
}
